import { useContext } from 'react'
import { Logo2x, LogoA2ATutelato } from '../../assets/images'
import { GlobalContext } from '../../contexts/Global'
import * as S from './style'

const NavBar = () => {
  const {
    state: { isAlternativeActive, forgotDetails },
  } = useContext(GlobalContext)
  return (
    <S.NavbarContainer forgotDetails={forgotDetails}>
      <S.NavbarItemsWrapper>
        <a
          href={
            isAlternativeActive
              ? process.env.REACT_APP_LOGO_TUTELATO_URL
              : process.env.REACT_APP_LOGO_URL
          }
        >
          {isAlternativeActive ? (
            <img
              src={LogoA2ATutelato}
              alt="LogoA2ATutelato"
              isAlternativeActive={isAlternativeActive}
            />
          ) : (
            <img src={Logo2x} alt="Logo" />
          )}
        </a>
      </S.NavbarItemsWrapper>
    </S.NavbarContainer>
  )
}

export default NavBar
